import { put, takeEvery } from "redux-saga/effects";
import { bearerRequest } from "services/requests.services";
import {
  DOWNLOAD_KYP_CSV,
  DOWNLOAD_KYP_CSV_SUCCESS,
  DOWNLOAD_KYP_CSV_FAILED,
  GET_KYP_DATA,
  GET_KYP_DATA_SUCCESS,
  GET_KYP_DATA_FAILED,
  GET_AUTOMATED_KYP_LEADS,
  GET_AUTOMATED_KYP_LEADS_SUCCESS,
  GET_AUTOMATED_KYP_LEADS_FAILED
} from "./Action";
import { servicePath } from "constants/defaultValues";

function* getKypData(action) {
  try {
    const { search = "", startDate = "", endDate = "", page = "", size = "" } = action.payload || {};

    const BASE_URL = `${servicePath}/kyp/list?search=${search ?? ""}&page=${page}&size=${size}`;
    const response = yield bearerRequest("POST", BASE_URL, { startDate, endDate });

    yield put({
      type: GET_KYP_DATA_SUCCESS,
      data: response?.data,
      totalCount: response?.totalCount,
      message: "KYP data fetched successfully",
    });
  } catch (error) {
    const apiErrorMessage = error?.response?.data?.message || error?.message || "Failed to fetch KYP data";
    yield put({
      type: GET_KYP_DATA_FAILED,
      message: apiErrorMessage,
    });
  }
}

function* postKypDataCSV(action) {
  try {
    const { startDate = "", endDate = "" , search = ""} = action.payload || {};

    const response = yield bearerRequest(
      "POST", 
      `${servicePath}/kyp/download/report`, 
      { startDate, endDate, search }, 
      { responseType: "blob" }
    );
    
    if (response) {
      yield put({
        type: DOWNLOAD_KYP_CSV_SUCCESS,
        data: response,
        message: "CSV downloaded successfully",
      });
    } else {
      throw new Error("Invalid response received");
    }
  } catch (error) {
    yield put({
      type: DOWNLOAD_KYP_CSV_FAILED,
      message: error?.message || "Error downloading CSV",
    });
  }
}


function* getAutomatedKypLeadsData(action) {
  try {
    const { page = "", size = "", filterType = "", startDate = "", endDate = "", search = "" } = action.payload || {};

    const BASE_URL = `${servicePath}/policy/automated-kyp-list?page=${page}&size=${size}&filterType=${filterType}&startDate=${startDate}&endDate=${endDate}&search=${search}`;
    const response = yield bearerRequest("GET", BASE_URL);

    yield put({
      type: GET_AUTOMATED_KYP_LEADS_SUCCESS,
      data: response?.data,
      totalCount: response?.totalCount,
      message: "KYP data fetched successfully",
    });
  } catch (error) {
    const apiErrorMessage = error?.response?.data?.message || error?.message || "Failed to fetch KYP data";
    yield put({
      type: GET_AUTOMATED_KYP_LEADS_FAILED,
      message: apiErrorMessage,
    });
  }
}



export default function* kypSaga() {
  yield takeEvery(GET_KYP_DATA, getKypData);
  yield takeEvery(DOWNLOAD_KYP_CSV, postKypDataCSV);
  yield takeEvery(GET_AUTOMATED_KYP_LEADS, getAutomatedKypLeadsData);
}
